import { useRef } from 'react';
import { INIT_MAP_DATA } from '../../../../../store';
import { getSearchFromHash } from '../../../../utils';
import { MapWidget } from '../MapWidget';
import { MapWidgetSearchParams } from './MapWidgetSearchParams';

export const QueryParser = () => {
  const search = getSearchFromHash(window.location.hash);
  const searchParamsRef = useRef(new MapWidgetSearchParams(search || ''));

  const searchParams = searchParamsRef.current;

  const zoom: number = searchParams.getZoom(INIT_MAP_DATA.zoom);
  const center: number[] = searchParams.getCenter(INIT_MAP_DATA.center);
  const legend: boolean = searchParams.getLegend(true);
  const card: boolean = searchParams.getCard(true);
  const layers: string[] = searchParams.getLayers([]);
  const news: boolean = searchParams.hasNews(false);
  const events: boolean = searchParams.hasEvents(false);

  return (
    <MapWidget
      zoom={zoom}
      center={center}
      initialRotation={0}
      enableRotation={false}
      legend={legend}
      card={card}
      layers={layers}
      news={news}
      events={events}
    />
  );
};
